import React from "react";

const SubjectExtraTools = ({
  onToolToggle = () => {},
  removeBackgroundActive,
  onRemoveBackgroundChange,
  hideReflection = false,
}) => {
  const [tools, setTools] = React.useState({
    removeBackground: true,
    reflection: false,
  });
  const [expandedTool, setExpandedTool] = React.useState(null);

  const isControlled = typeof removeBackgroundActive === "boolean";
  const removeBgEnabled = isControlled
    ? removeBackgroundActive
    : tools.removeBackground;

  const handleToolToggle = (toolName) => {
    if (toolName === "removeBackground" && isControlled) {
      const nextEnabled = !removeBgEnabled;
      onRemoveBackgroundChange?.(nextEnabled);
      onToolToggle(toolName, nextEnabled);
      return;
    }
    setTools((prev) => {
      const nextEnabled = !prev[toolName];
      onToolToggle(toolName, nextEnabled);
      return { ...prev, [toolName]: nextEnabled };
    });
  };

  const TOOLS = [
    { id: "removeBackground", label: "Remove Background", icon: "🗑️" },
    ...(hideReflection
      ? []
      : [{ id: "reflection", label: "Reflection", icon: "✨" }]),
  ];

  return (
    <div className="subject-tools-list">
      {TOOLS.map((tool) => (
        <div key={tool.id} className="subject-tool-item">
          <div className="subject-tool-left">
            <span className="subject-tool-icon">{tool.icon}</span>
            <span className="subject-tool-label">{tool.label}</span>
          </div>
          <div className="subject-tool-right">
            <button
              className={`subject-toggle-btn ${
                (tool.id === "removeBackground" ? removeBgEnabled : tools[tool.id])
                  ? "active"
                  : ""
              }`}
              onClick={() => handleToolToggle(tool.id)}
              aria-label={`Toggle ${tool.label}`}
            >
              <div className="toggle-circle"></div>
            </button>
            <button
              className={`subject-tool-arrow ${expandedTool === tool.id ? "expanded" : ""}`}
              onClick={() =>
                setExpandedTool(expandedTool === tool.id ? null : tool.id)
              }
              aria-label={`${tool.label} options`}
            >
              ›
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SubjectExtraTools;
